import type { LanguageConfig } from '@/types'

// Hebrew language configuration - complete and self-contained
export const hebrew: LanguageConfig = {
  code: 'he',
  name: 'עברית',
  dir: 'rtl',
  path: '',  // Root path for Hebrew

  manifest: {
    name: 'חיתוך שירים ואודיו MP3 / WAV',
    shortName: 'חיתוך שירים'
  },

  seo: {
    // Meta
    title: 'חיתוך שירים וקבצי אודיו MP3/WAV - ללא העלאה, 100% פרטי | CutMP3',
    description: 'חתכו קבצי MP3 ואודיו בחינם, ישירות בדפדפן. ללא העלאה לשרת - הקבצים לא עוזבים את המכשיר שלכם. ללא הרשמה, ללא סימן מים. חתכו שירים וצרו רינגטונים בשניות.',
    keywords: 'חותך אודיו, חיתוך MP3, חיתוך WAV, עריכת אודיו, חיתוך שירים, חותך שירים, עריכת קבצי אודיו, חיתוך מקוון, חיתוך אודיו חינם, חיתוך MP3 עברית, חותך WAV, עריכת OGG, חיתוך AAC, חיתוך FLAC, חיתוך שירים עברית, עורך אודיו מקוון, חיתוך אודיו ללא העלאה, חיתוך MP3 פרטי, חיתוך שירים בדפדפן',

    // Open Graph
    ogLocale: 'he_IL',
    ogTitle: 'חיתוך שירים וקבצי אודיו MP3/WAV - ללא העלאה, 100% פרטי',
    ogDescription: 'חתכו קבצי MP3 ואודיו בחינם, ישירות בדפדפן. ללא העלאה לשרת - הקבצים לא עוזבים את המכשיר שלכם. ללא הרשמה, ללא סימן מים.',
    ogSiteName: 'Audio Cutter',

    // Twitter
    twitterTitle: 'חיתוך שירים וקבצי אודיו MP3/WAV - ללא העלאה, 100% פרטי',
    twitterDescription: 'חתכו קבצי MP3 ואודיו בחינם, ישירות בדפדפן. ללא העלאה לשרת - הקבצים לא עוזבים את המכשיר שלכם. ללא הרשמה, ללא סימן מים.',
    
    // PWA
    appleWebAppTitle: 'חותך אודיו',
    
    // JSON-LD Schema
    schemaName: 'חיתוך שירים וקבצי אודיו MP3/WAV - חינם ובממשק בעברית',
    schemaDescription: 'חותך אודיו מקוון חינם - חתוך קבצי MP3, WAV, OGG, AAC, FLAC בקלות בממשק בעברית. עריכה ויזואלית ללא התקנה',
    schemaFeatureList: [
      'חיתוך קבצי אודיו MP3, WAV, OGG, AAC, FLAC',
      'עריכה ויזואלית עם תצוגת גל',
      'ייצוא באיכות גבוהה',
      'חיתוך שירים',
      'ממשק בעברית',
      'ללא צורך בהתקנה'
    ],
    schemaCurrency: 'ILS',

    // HowTo Schema
    schemaHowToName: 'איך לחתוך קובץ אודיו אונליין בחינם',
    schemaHowToDescription: 'חיתוך קבצי MP3, WAV ואודיו נוספים אונליין בחינם באמצעות חותך אודיו בדפדפן. ללא העלאה לשרת - הקבצים נשארים פרטיים במכשיר שלכם.',
    schemaHowToSteps: [
      { name: 'בחרו קובץ אודיו', text: 'לחצו על הכפתור "בחר קובץ אודיו" או גררו את הקובץ לאזור ההעלאה. ניתן לטעון קבצי MP3, WAV, OGG, AAC או FLAC. הקובץ נטען ישירות בדפדפן ללא העלאה לשרת.' },
      { name: 'עריכה וחיתוך', text: 'השתמשו בעורך הוויזואלי כדי לבחור את הקטע המדויק שתרצו. גררו את סמני ההתחלה והסוף על גל השמע. השתמשו בכפתור הנגן כדי להאזין לקטע שבחרתם ולדייק את נקודות החיתוך.' },
      { name: 'הורדת הקובץ החתוך', text: 'לחצו על כפתור הייצוא, בחרו את פורמט הפלט (MP3 או WAV) והורידו את קובץ האודיו החתוך. העיבוד מתבצע כולו בדפדפן שלכם לפרטיות ומהירות מקסימלית.' }
    ],

    // Breadcrumb
    schemaBreadcrumbHome: 'ראשי'
  },

  ui: {
    title: 'חיתוך שירים וקבצי אודיו MP3 / WAV',
    subtitle: 'חתכו שירים וקבצי שמע בפרטיות מלאה - ללא העלאה, ללא הרשמה, ללא סימן מים',

    // Instructions
    instructionsHeading: 'איך לחתוך אודיו אונליין ב-3 שלבים פשוטים',
    instructionSelectTitle: 'בחרו קובץ אודיו',
    instructionSelectDesc: 'לחצו על הכפתור "בחר קובץ אודיו" למעלה ובחרו מהמחשב את קובץ ה-MP3, WAV, OGG, AAC או FLAC שתרצו לערוך ולחתוך ממנו קטע ספציפי. התמיכה בכל פורמטי האודיו הפופולריים',
    instructionEditTitle: 'עריכה וחיתוך',
    instructionEditDesc: 'הזיזו את הסמנים על גל השמע לקטע הרצוי לחיתוך. תוכלו להאזין לחלק שבחרתם באמצעות כפתור הנגן, לחזור לתחילת הקטע ולדייק את החיתוך בצורה מושלמת עם תצוגה ויזואלית של הגל',
    instructionExportTitle: 'ייצוא והורדה',
    instructionExportDesc: 'לחצו על כפתור הייצוא ובחרו את פורמט הקובץ הרצוי - MP3 או WAV. הקובץ החתוך יורד ישירות למחשב שלכם באיכות מעולה ומוכן לשימוש',

    // Footer
    footerDescription: 'חיתוך שירים MP3 ו-WAV בחינם - העיבוד מתבצע בדפדפן באופן מאובטח ופרטי',
    footerKeywords: 'חיתוך שירים | עריכת אודיו | חותך MP3 | עריכת קבצי WAV | חיתוך קבצי אודיו מקוון בעברית',
    footerMadeWith: 'Made with',
    footerBy: 'by',

    uploadPrompt: 'בחר קובץ אודיו (MP3, WAV, OGG, AAC, FLAC) או גרור אותו לכאן',
    uploadButton: 'בחר קובץ אודיו',
    dragDropText: 'גרור ושחרר קובץ כאן',
    supportedFormats: 'פורמטים נתמכים: MP3, WAV, OGG, AAC, FLAC, M4A',
    startTime: 'זמן התחלה',
    endTime: 'זמן סיום',
    duration: 'משך',
    play: 'נגן',
    pause: 'השהה',
    stop: 'עצור',
    replay: 'חזרה להתחלה',
    loop: 'חזרה',
    export: 'ייצוא',
    exporting: 'מייצא...',
    format: 'פורמט',
    quality: 'איכות',
    download: 'הורד',
    reset: 'קובץ חדש',
    cancel: 'ביטול',
    error: 'שגיאה',
    success: 'הצלחה',
    loading: 'טוען...',
    processing: 'מעבד...',
    invalidFile: 'קובץ לא תקין. אנא בחר קובץ אודיו.',
    fileTooLarge: 'הקובץ גדול מדי. הגודל המקסימלי הוא 100MB.',
    unsupportedFormat: 'פורמט לא נתמך. נא לבחור קובץ MP3, WAV, OGG, AAC או FLAC.',
    exportSuccess: 'הקובץ יוצא בהצלחה!',
    exportError: 'אירעה שגיאה בייצוא הקובץ. נא לנסות שוב.',

    // Feedback Form
    contactTitle: 'שלחו לנו הודעה',
    contactText: 'אהבתם את הכלי? נשמח לשמוע. נתקלתם בבעיה או יש לכם רעיון לשיפור? נשמח שתספרו לנו.',
    contactButton: 'שלחו פידבק',
    contactName: 'שם מלא *',
    contactNamePlaceholder: 'הזן את שמך',
    contactEmail: 'אימייל *',
    contactEmailPlaceholder: 'example@email.com',
    contactSubject: 'נושא',
    contactSubjectPlaceholder: 'נושא הפנייה',
    contactMessage: 'הודעה *',
    contactMessagePlaceholder: 'כתוב את הודעתך כאן...',
    contactSubmit: 'שלח הודעה',
    contactSubmitting: 'שולח...',
    contactCancel: 'ביטול',
    contactSuccessTitle: 'ההודעה נשלחה בהצלחה!',
    contactSuccessText: 'תודה שפנית אלינו.',
    contactErrorTitle: 'שגיאה בשליחת ההודעה',
    contactErrorText: 'אנא נסו שנית או שלחו אימייל ישירות:',
    contactEmailLink: 'audio.cutter.israel@gmail.com',
    contactRetry: 'נסה שוב',
    contactClose: 'סגור',

    // Edit mode
    modeCut: 'חיתוך',
    modeTrim: 'קיצוץ',
    modeCutTooltip: 'שמור את הקטע הנבחר, הסר את ההתחלה והסוף',
    modeTrimTooltip: 'הסר את הקטע הנבחר, שמור את ההתחלה והסוף',

    // FAQ
    faqTitle: 'שאלות נפוצות',
    faqItems: [
      { question: 'איך חותכים קובץ MP3 אונליין?', answer: 'פשוט לחצו על "בחר קובץ אודיו" כדי לטעון את ה-MP3, השתמשו בעורך גל השמע לבחירת הקטע הרצוי, ולחצו על ייצוא כדי להוריד את הקובץ החתוך. כל התהליך מתבצע בדפדפן שלכם.' },
      { question: 'האם חותך האודיו הזה בחינם?', answer: 'כן, בחינם לחלוטין ללא הגבלות. אין עלויות נסתרות, אין סימני מים, ואין צורך בהרשמה. ניתן לחתוך כמה קבצים שתרצו.' },
      { question: 'אילו פורמטי אודיו נתמכים?', answer: 'אנו תומכים בקבצי MP3, WAV, OGG, AAC, FLAC ו-M4A. ניתן לייצא את האודיו החתוך בפורמט MP3 או WAV.' },
      { question: 'אפשר ליצור רינגטונים עם הכלי הזה?', answer: 'בהחלט! בחרו את השיר, חתכו אותו לאורך הרצוי (בדרך כלל 30 שניות לרינגטון), וייצאו כ-MP3. הקובץ מוכן לשימוש כרינגטון בטלפון שלכם.' },
      { question: 'האם זה בטוח? האם הקבצים שלי מועלים לשרת?', answer: 'הקבצים שלכם לעולם לא עוזבים את המכשיר. כל עיבוד האודיו מתבצע כולו בדפדפן שלכם באמצעות טכנולוגיית Web Audio API. אף קובץ לא מועלה לשום שרת, מה שמבטיח פרטיות מלאה.' },
      { question: 'מה הגודל המקסימלי לקובץ?', answer: 'ניתן לעבד קבצי אודיו עד 100MB. מכיוון שכל העיבוד מתבצע מקומית בדפדפן שלכם, קבצים גדולים יותר עשויים לקחת רגע לטעינה בהתאם למכשיר שלכם.' },
      { question: 'איך מסירים קטע מאמצע קובץ אודיו?', answer: 'השתמשו במצב קיצוץ (לחצו על כפתור "קיצוץ" מעל גל השמע). בחרו את הקטע שברצונכם להסיר, והכלי ישמור את כל מה שלפני ואחרי הבחירה שלכם ויסיר את החלק האמצעי.' }
    ],
    relatedToolsTitle: 'כלים נוספים',

    // Privacy trust badges
    trustItems: [
      { title: 'ללא העלאה - 100% בדפדפן שלכם', text: 'האודיו מעובד במכשיר שלכם עם טכנולוגיית Web Audio. הקבצים לעולם לא מגיעים לשרת.' },
      { title: 'חינם, ללא הרשמה, ללא סימן מים', text: 'חיתוכים ללא הגבלה וייצוא באיכות מלאה. בלי חשבונות, בלי עלויות נסתרות - חינם לתמיד.' },
      { title: 'אין צורך בהתקנה - עובד בכל מכשיר', text: 'טלפון, טאבלט או מחשב - חותכים אודיו ישירות מהדפדפן, בלי אפליקציה.' }
    ],

    // Accessibility
    skipToContent: 'דלג לתוכן',
    required: 'שדה חובה',
  },

  formatLabels: {
    mp3: 'MP3',
    wav: 'WAV',
    ogg: 'OGG',
    aac: 'AAC'
  },

  qualityLabels: {
    low: 'נמוכה (128 kbps)',
    medium: 'בינונית (192 kbps)',
    high: 'גבוהה (256 kbps)',
    best: 'מעולה (320 kbps)'
  },

  spokes: {
    'mp3-wav-converter': {
      slug: 'mp3-wav-converter',
      ui: {
        title: 'ממיר MP3 ל-WAV (וגם WAV ל-MP3)',
        subtitle: 'המרת קבצי אודיו ל-MP3 או WAV ישירות בדפדפן - בחינם ובלי העלאות',
        heroText: 'המירו בין MP3 ל-WAV תוך שניות. טענו כל קובץ MP3, WAV, OGG, AAC, FLAC או M4A וייצאו אותו כ-MP3 (עד 320 kbps) או WAV ללא דחיסה - בלי להתקין כלום ובלי שהקובץ עוזב את המכשיר שלכם. בלי חיתוך ובלי עריכה - פשוט טוענים קובץ, בוחרים פורמט פלט ומורידים.',
        faqItems: [
          { question: 'איך ממירים MP3 ל-WAV?', answer: 'טענו את קובץ ה-MP3, לחצו על ייצוא ובחרו WAV כפורמט הפלט. הקובץ מפוענח ונשמר כאודיו WAV ללא דחיסה - בלי העלאה לשרת, הכול קורה בדפדפן שלכם.' },
          { question: 'איך ממירים WAV ל-MP3?', answer: 'טענו את קובץ ה-WAV, לחצו על ייצוא, בחרו MP3 וקבעו את הקצב (128-320 kbps). ב-320 kbps התוצאה כמעט בלתי ניתנת להבחנה מהמקור עבור רוב המאזינים.' },
          { question: 'מאילו פורמטים אפשר להמיר?', answer: 'אפשר לטעון קבצי MP3, WAV, OGG, AAC, FLAC ו-M4A. הפלט יכול להיות MP3 או WAV, כך שאפשר להמיר כל אחד מהפורמטים האלה לשניהם.' },
          { question: 'MP3 או WAV - מה כדאי לבחור?', answer: 'בחרו WAV לאיכות מרבית ולעריכה נוספת (ללא דחיסה). בחרו MP3 לקבצים קטנים יותר שקל לשתף ולהשמיע בכל מקום, למשל בסלולרי או באפליקציות הודעות.' },
          { question: 'האם האודיו מועלה לשרת?', answer: 'לא. ההמרה מתבצעת כולה בדפדפן שלכם באמצעות JavaScript. הקבצים לעולם לא עוזבים את המכשיר, כך שגם הקלטות ארוכות מומרות במהירות ובפרטיות.' },
          { question: 'אפשר לחתוך רק חלק מהקובץ?', answer: 'הדף הזה ממיר קבצים שלמים. אם תרצו לחלץ רק קטע משיר או הקלטה, השתמשו בחותך האודיו הראשי בדף הבית - הוא תומך באותם פורמטים וגם מייצא MP3 ו-WAV.' }
        ],
        instructionsHeading: 'איך ממירים אודיו אונליין ב-3 שלבים פשוטים',
        instructionSelectTitle: 'טענו את הקובץ',
        instructionSelectDesc: 'לחצו על כפתור "בחירת קובץ אודיו" או גררו לתוך האזור קובץ MP3, WAV, OGG, AAC, FLAC או M4A. הקובץ נטען מיד בדפדפן - שום דבר לא מועלה לשרת.',
        instructionEditTitle: 'בחרו פורמט פלט',
        instructionEditDesc: 'בחרו MP3 (עם הקצב הרצוי, עד 320 kbps) או WAV ללא דחיסה. לא צריך עריכה - את כל הקובץ ממירים.',
        instructionExportTitle: 'הורידו את הקובץ',
        instructionExportDesc: 'לחצו על ייצוא והורידו את קובץ האודיו המומר. ההמרה מתבצעת כולה במכשיר שלכם - פרטיות ומהירות מרביות.'
      },
      seo: {
        title: 'המרת MP3 ל-WAV – ממיר WAV ל-MP3 בחינם | CutMP3',
        description: 'המירו MP3 ל-WAV או WAV ל-MP3 בחינם בדפדפן. תמיכה גם ב-OGG, AAC, FLAC ו-M4A. בלי העלאה, בלי הרשמה, בלי התקנות.',
        keywords: 'המרת mp3 ל-wav, המרת wav ל-mp3, ממיר mp3 ל-wav אונליין, ממיר אודיו בחינם, המרת ogg ל-mp3, המרת m4a ל-wav, ממיר קבצי אודיו בלי העלאה',
        ogTitle: 'המרת MP3 ל-WAV – ממיר WAV ל-MP3 בחינם',
        ogDescription: 'המירו בין MP3 ל-WAV בדפדפן. בלי העלאות והתקנות - 100% פרטי.',
        twitterTitle: 'המרת MP3 ל-WAV – ממיר WAV ל-MP3 בחינם',
        twitterDescription: 'המירו בין MP3 ל-WAV בדפדפן. בלי העלאות והתקנות.',
        schemaName: 'ממיר MP3 ל-WAV',
        schemaDescription: 'ממיר מקוון בחינם בין MP3 ל-WAV (תמיכה גם ב-OGG, AAC, FLAC ו-M4A). פועל כולו בדפדפן - הקבצים לעולם לא עוזבים את המכשיר.',
        schemaFeatureList: [
          'המרת MP3 ל-WAV',
          'המרת WAV ל-MP3 (עד 320 kbps)',
          'תמיכה בקבצי OGG, AAC, FLAC ו-M4A',
          'בחירת איכות וקצב דגימה',
          'בלי העלאה - ההמרה מתבצעת בדפדפן',
          'בחינם - בלי הרשמה או התקנה'
        ],
        schemaHowToName: 'איך להמיר MP3 ל-WAV אונליין',
        schemaHowToDescription: 'המירו MP3 ל-WAV (או WAV ל-MP3) בחינם בדפדפן, בלי להעלות קבצים לשרת.',
        schemaHowToSteps: [
          { name: 'טענו את הקובץ', text: 'לחצו על "בחירת קובץ אודיו" או גררו לתוך האזור קובץ MP3, WAV, OGG, AAC, FLAC או M4A. הקובץ מפוענח מיד בדפדפן.' },
          { name: 'בחרו את פורמט הפלט', text: 'לחצו על ייצוא ובחרו MP3 (עם הקצב הרצוי) או WAV ללא דחיסה.' },
          { name: 'הורידו את הקובץ המומר', text: 'לחצו על הורדה כדי לשמור את קובץ האודיו המומר. כל ההמרה מתבצעת במכשיר שלכם.' }
        ]
      }
    },
    'make-iphone-ringtone': {
      slug: 'make-iphone-ringtone',
      ui: {
        title: 'יצירת רינגטון לאייפון בחינם',
        subtitle: 'צרו רינגטונים מותאמים אישית מכל קובץ שמע - עד 40 שניות',
        heroText: 'הפכו כל קובץ MP3, WAV או שמע לרינגטון מותאם אישית לאייפון. הכלי החינמי שלנו מאפשר לבחור קליפ של 30 שניות, לחתוך אותו בדיוק ולהוריד אותו מוכן לאייפון. ללא התקנת תוכנה.',
        faqItems: [
          { question: 'איך יוצרים רינגטון לאייפון?', answer: 'העלו את קובץ השמע, השתמשו בעורך גל השמע לבחירת קליפ של 30 שניות או פחות, וייצאו כ-MP3. לאחר מכן הוסיפו אותו לאייפון דרך iTunes/Finder או אפליקציית מנהל קבצים.' },
          { question: 'מה האורך המקסימלי לרינגטון באייפון?', answer: 'רינגטונים לאייפון יכולים להיות עד 40 שניות, אך 30 שניות הוא האורך הנפוץ ביותר. השתמשו בכלי החיתוך שלנו כדי לחתוך את השמע לאורך המושלם.' },
          { question: 'באיזה פורמט צריכים להיות רינגטונים לאייפון?', answer: 'רינגטונים לאייפון משתמשים בפורמט M4R, אך אפשר להתחיל מכל פורמט שמע. ייצאו כ-MP3 מהכלי שלנו, ואז שנו את הסיומת ל-.m4r או המירו באמצעות iTunes.' },
          { question: 'אפשר ליצור רינגטון מסרטון יוטיוב?', answer: 'תחילה תצטרכו להוריד את השמע מהסרטון באמצעות כלי נפרד. ברגע שיש לכם את קובץ השמע (MP3, WAV וכו\'), העלו אותו כאן כדי לחתוך אותו לרינגטון.' },
          { question: 'האם יוצר הרינגטונים הזה בחינם לגמרי?', answer: 'כן, 100% בחינם ללא הגבלות. צרו כמה רינגטונים שתרצו, ללא צורך בהרשמה, והקבצים שלכם לעולם לא עוזבים את הדפדפן לפרטיות מלאה.' }
        ]
      },
      seo: {
        title: 'יצירת רינגטון לאייפון בחינם - רינגטונים מותאמים אישית אונליין | CutMP3',
        description: 'צרו רינגטונים מותאמים אישית לאייפון מכל קובץ שמע בחינם. חתכו ל-30 שניות והורידו - ללא העלאה, המוזיקה לא עוזבת את המכשיר שלכם. עובד בדפדפן.',
        keywords: 'יצירת רינגטון לאייפון, רינגטון מותאם אישית, חיתוך רינגטון, יוצר רינגטונים חינם, MP3 לרינגטון, חותך רינגטון, רינגטון מותאם אישית לאייפון',
        ogTitle: 'יצירת רינגטון לאייפון בחינם - רינגטונים מותאמים אישית אונליין',
        ogDescription: 'צרו רינגטונים מותאמים אישית לאייפון מכל קובץ שמע בחינם. העלו, חתכו ל-30 שניות, הורידו. ללא התקנה.',
        twitterTitle: 'יצירת רינגטון לאייפון בחינם - רינגטונים מותאמים אישית אונליין',
        twitterDescription: 'צרו רינגטונים מותאמים אישית לאייפון מכל קובץ שמע בחינם. העלו, חתכו, הורידו.',
        schemaName: 'יצירת רינגטון לאייפון בחינם',
        schemaDescription: 'צרו רינגטונים מותאמים אישית לאייפון מכל קובץ שמע. העלו MP3, WAV או שמע אחר, חתכו לאורך המושלם, והורידו בחינם.',
        schemaFeatureList: [
          'יצירת רינגטונים לאייפון מכל קובץ שמע',
          'חיתוך שמע לקליפ של 30 שניות לרינגטון',
          'עורך ויזואלי של גל שמע לחיתוך מדויק',
          'תמיכה ב-MP3, WAV, OGG, AAC, FLAC',
          'חינם - ללא הרשמה או התקנה',
          'פרטי - השמע לעולם לא עוזב את הדפדפן'
        ],
        schemaHowToName: 'איך ליצור רינגטון לאייפון אונליין',
        schemaHowToDescription: 'צרו רינגטון מותאם אישית לאייפון על ידי העלאת קובץ שמע, חיתוך ל-30 שניות, והורדת התוצאה.',
        schemaHowToSteps: [
          { name: 'העלו את השמע', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את קובץ ה-MP3, WAV או שמע אחר. הוא נטען מיידית בדפדפן.' },
          { name: 'חתכו לאורך רינגטון', text: 'השתמשו בעורך גל השמע לבחירת קליפ של 30 שניות. גררו את הסמנים כדי לבחור את החלק הטוב ביותר של השיר לרינגטון.' },
          { name: 'הורידו את הרינגטון', text: 'לחצו על ייצוא, בחרו פורמט MP3, והורידו. העבירו את הקובץ לאייפון דרך iTunes, Finder או אפליקציית מנהל קבצים.' }
        ]
      }
    },
    'cut-audio-for-instagram': {
      slug: 'cut-audio-for-instagram',
      ui: {
        title: 'חיתוך שמע לאינסטגרם רילס וסטוריז',
        subtitle: 'חתכו קליפים לאינסטגרם, טיקטוק ורשתות חברתיות - אורך מושלם בכל פעם',
        heroText: 'צריכים קליפ שמע מושלם לרילס או סטורי באינסטגרם? הכלי החינמי שלנו מאפשר לחתוך כל שיר או קובץ שמע בדיוק לאורך שצריכים לרשתות חברתיות. חתכו, האזינו, והורידו בשניות.',
        faqItems: [
          { question: 'מה אורך השמע המיטבי לרילס באינסטגרם?', answer: 'רילס באינסטגרם יכולים להיות עד 90 שניות. למקסימום אינטראקציה, 15-30 שניות הם האידיאל. השתמשו בעורך שלנו כדי לחתוך את השמע לאורך המושלם.' },
          { question: 'אפשר לחתוך שמע לסטוריז באינסטגרם?', answer: 'כן! סטוריז באינסטגרם הם 15 שניות לכל שקופית. חתכו את קליפ השמע בדיוק ל-15 שניות (או כפולות) לפסקול סטורי חלק.' },
          { question: 'באיזה פורמט שמע אינסטגרם מקבלת?', answer: 'אינסטגרם תומכת בשמע MP3 ו-AAC. ייצאו את השמע החתוך כ-MP3 מהכלי שלנו והוא מוכן לשימוש ברילס או בסטוריז.' },
          { question: 'אפשר להשתמש בזה גם לשמע בטיקטוק?', answer: 'בהחלט! חותך השמע שלנו עובד לכל פלטפורמת רשתות חברתיות. חתכו את השמע לאורך הרצוי והשתמשו בו בטיקטוק, אינסטגרם, YouTube Shorts או כל פלטפורמה אחרת.' },
          { question: 'איך מוסיפים שמע חתוך לרילס באינסטגרם?', answer: 'אחרי הורדת השמע החתוך, פתחו את אינסטגרם, צרו רילס חדש, והשתמשו באפשרות "הוסף שמע" כדי להעלות את הקליפ המותאם מהמכשיר שלכם.' }
        ]
      },
      seo: {
        title: 'חיתוך שמע לאינסטגרם רילס וסטוריז - כלי מקוון חינמי | CutMP3',
        description: 'חתכו שמע לאינסטגרם בחינם. חיתוך שמע לרילס (15-90 שניות), סטוריז (15 שניות) וטיקטוק ישירות בדפדפן - ללא העלאה, ללא הרשמה, ללא סימן מים.',
        keywords: 'חיתוך שמע לאינסטגרם, חיתוך שמע לרילס, שמע לרילס, שמע לסטוריז, חותך שמע לטיקטוק, עורך שמע לרשתות חברתיות, חיתוך מוזיקה לאינסטגרם, חיתוך שיר לרילס, קיצור שיר לרילס, מוזיקה לרילס באינסטגרם',
        ogTitle: 'חיתוך שמע לאינסטגרם רילס וסטוריז - כלי מקוון חינמי',
        ogDescription: 'חתכו שמע לרילס וסטוריז באינסטגרם. חתכו שירים לאורך המושלם לרשתות חברתיות. חינם ומהיר.',
        twitterTitle: 'חיתוך שמע לאינסטגרם רילס וסטוריז - כלי מקוון חינמי',
        twitterDescription: 'חתכו שמע לרילס וסטוריז באינסטגרם. חתכו שירים לאורך המושלם. חינם ומהיר.',
        schemaName: 'חיתוך שמע לאינסטגרם - חותך שמע לרשתות חברתיות',
        schemaDescription: 'כלי מקוון חינמי לחיתוך שמע לרילס, סטוריז באינסטגרם, טיקטוק ורשתות חברתיות. חתכו שירים לאורך המושלם.',
        schemaFeatureList: [
          'חיתוך שמע לרילס באינסטגרם (עד 90 שניות)',
          'חיתוך קליפים לסטוריז באינסטגרם (15 שניות)',
          'מושלם לטיקטוק ו-YouTube Shorts',
          'עורך ויזואלי של גל שמע לחיתוך מדויק',
          'ייצוא כ-MP3 מוכן לרשתות חברתיות',
          'חינם - ללא הרשמה או התקנה'
        ],
        schemaHowToName: 'איך לחתוך שמע לרילס באינסטגרם',
        schemaHowToDescription: 'חתכו כל קובץ שמע לאורך המושלם לרילס, סטוריז באינסטגרם או פלטפורמות רשתות חברתיות אחרות.',
        schemaHowToSteps: [
          { name: 'העלו את השמע', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את השיר או קליפ השמע. תומך ב-MP3, WAV ופורמטים נוספים.' },
          { name: 'חתכו לאורך הנכון', text: 'השתמשו בעורך גל השמע לבחירת הקליפ המושלם. לרילס, כוונו ל-15-30 שניות. לסטוריז, חתכו בדיוק ל-15 שניות.' },
          { name: 'הורידו לרשתות חברתיות', text: 'לחצו על ייצוא, בחרו MP3, והורידו. העלו את השמע החתוך ישירות לאינסטגרם, טיקטוק או כל פלטפורמה חברתית.' }
        ]
      }
    },
    'trim-voice-recording': {
      slug: 'trim-voice-recording',
      ui: {
        title: 'חיתוך הקלטות קוליות אונליין',
        subtitle: 'ניקוי תזכורות קוליות והקלטות - הסרת שקט וחלקים מיותרים',
        heroText: 'חתכו במהירות תזכורות קוליות, ראיונות והודעות קוליות. הסירו שתיקות מביכות, התחלות שגויות וקטעים מיותרים עם העורך הוויזואלי החינמי שלנו. ללא העלאה לשרת.',
        faqItems: [
          { question: 'איך חותכים תזכורת קולית?', answer: 'העלו את התזכורת הקולית (MP3, M4A, WAV וכו\'), השתמשו בתצוגת גל השמע כדי לזהות ולבחור חזותית את החלק שרוצים לשמור, ואז ייצאו. פשוט כמו שזה.' },
          { question: 'אפשר להסיר שקט מהקלטה?', answer: 'כן! השתמשו בגל השמע הוויזואלי כדי לזהות קטעי שקט (אזורים שטוחים). בחרו את החלק שרוצים לשמור במצב חיתוך, או בחרו שקט מיותר והשתמשו במצב קיצוץ כדי להסיר אותו.' },
          { question: 'אילו פורמטי הקלטה קולית נתמכים?', answer: 'אנו תומכים בכל פורמטי ההקלטה הקולית הנפוצים: MP3, M4A (תזכורות קוליות של אייפון), WAV, OGG, AAC ו-FLAC. ייצוא כ-MP3 או WAV.' },
          { question: 'אפשר לחתוך שמע של פודקאסט עם הכלי הזה?', answer: 'כן! העלו את הקלטת הפודקאסט, השתמשו בעורך גל השמע כדי לחתוך פתיחות, סגירות, טעויות או כל קטע מיותר. מושלם לעריכת פודקאסט מהירה.' },
          { question: 'האם ההקלטה הקולית שלי נשמרת פרטית?', answer: 'בהחלט. ההקלטה מעובדת כולה בדפדפן שלכם. שום דבר לא מועלה לשרת כלשהו. השמע שלכם נשאר פרטי לחלוטין במכשיר שלכם.' }
        ]
      },
      seo: {
        title: 'חיתוך הקלטות קוליות אונליין בחינם - תזכורות קוליות | CutMP3',
        description: 'חתכו הקלטות קוליות ותזכורות קוליות אונליין בחינם. הסירו שקט, חתכו חלקים מיותרים. פרטי - הקבצים לעולם לא עוזבים את הדפדפן.',
        keywords: 'חיתוך הקלטה קולית, חיתוך תזכורת קולית, חותך הקלטות, עריכת הקלטה קולית אונליין, חיתוך הודעה קולית, עורך תזכורות קוליות, חיתוך תזכורת קולית M4A',
        ogTitle: 'חיתוך הקלטות קוליות אונליין בחינם - תזכורות קוליות',
        ogDescription: 'חתכו הקלטות קוליות ותזכורות קוליות אונליין בחינם. הסירו שקט וחלקים מיותרים. פרטי - הקבצים לעולם לא עוזבים את הדפדפן.',
        twitterTitle: 'חיתוך הקלטות קוליות אונליין בחינם - תזכורות קוליות',
        twitterDescription: 'חתכו הקלטות קוליות אונליין בחינם. הסירו שקט וחלקים מיותרים. פרטי ומהיר.',
        schemaName: 'חיתוך הקלטות קוליות אונליין',
        schemaDescription: 'כלי מקוון חינמי לחיתוך הקלטות קוליות, תזכורות קוליות ושמע פודקאסט. הסירו שקט וקטעים מיותרים עם עורך ויזואלי.',
        schemaFeatureList: [
          'חיתוך תזכורות קוליות והקלטות',
          'הסרת שקט משמע',
          'עריכת הקלטות פודקאסט',
          'תמיכה ב-M4A, MP3, WAV ועוד',
          'גל שמע ויזואלי לעריכה מדויקת',
          'פרטי - הקלטות לעולם לא עוזבות את הדפדפן'
        ],
        schemaHowToName: 'איך לחתוך הקלטה קולית אונליין',
        schemaHowToDescription: 'נקו תזכורות קוליות, הקלטות פודקאסט והערות שמע על ידי חיתוך קטעים מיותרים עם עורך מבוסס דפדפן חינמי.',
        schemaHowToSteps: [
          { name: 'העלו את ההקלטה', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את התזכורת הקולית, הפודקאסט או ההקלטה. תומך ב-M4A, MP3, WAV ופורמטים נוספים.' },
          { name: 'חתכו קטעים מיותרים', text: 'השתמשו בעורך גל השמע כדי לזהות ולהסיר שקט, התחלות שגויות או חלקים מיותרים. השתמשו במצב חיתוך לשמירת קטע או במצב קיצוץ להסרתו.' },
          { name: 'הורידו את ההקלטה החתוכה', text: 'לחצו על ייצוא, בחרו את הפורמט, והורידו את ההקלטה הנקייה. מוכנה לשיתוף, פרסום או שמירה.' }
        ]
      }
    },
    'wedding-first-dance-song': {
      slug: 'wedding-first-dance-song',
      ui: {
        title: 'חיתוך שיר לריקוד הראשון בחתונה',
        subtitle: 'קצרו כל שיר לסלואו, לכניסה לחופה או לרחבה - בחינם ובפרטיות מלאה',
        heroText: 'הפכו את הריקוד הראשון לאורך המושלם. העלו את שיר החתונה, בחרו את הבית והפזמון שאתם אוהבים, האזינו בלופ, והורידו חיתוך נקי לדיג\'יי. הכל מתבצע בדפדפן - השיר שלכם נשאר פרטי.',
        faqItems: [
          { question: 'מה האורך המומלץ לשיר לריקוד ראשון?', answer: 'רוב הזוגות מכוונים ל-60-120 שניות - מספיק כדי ליהנות מהרגע, וקצר מספיק כדי שהאורחים יישארו איתכם. שיר מלא של 3-4 דקות מרגיש לרוב ארוך מדי על הרחבה, ולכן חיתוך לבית ולפזמון הכי טובים הוא בחירה פופולרית.' },
          { question: 'איך מקצרים שיר בלי שהחיתוך יישמע קטוע?', answer: 'חתכו על גבול של משפט מוזיקלי: התחילו את הבחירה רגע לפני שבית או פזמון מתחילים, וסיימו כשהמשפט המוזיקלי נסגר. השתמשו בכפתור הלופ כדי להאזין לקטע שוב ושוב ולכוונן את הסמנים עד שהחיתוך מרגיש טבעי.' },
          { question: 'אפשר לחתוך גם שירי כניסה ומוזיקה לרחבה?', answer: 'בהחלט. השתמשו באותו כלי כדי לקצר את שיר הכניסה לחופה, את המוזיקה לקבלת הפנים, את השיר לחיתוך העוגה או פתיחים לפלייליסט - בדיוק לאורך שלוח הזמנים של החתונה דורש.' },
          { question: 'האם שיר החתונה שלי נשאר פרטי?', answer: 'כן. השיר לא עוזב את המכשיר שלכם - כל החיתוך מתבצע בדפדפן ללא העלאה לשום שרת. הורידו את החיתוך כ-MP3 או WAV ומסרו לדיג\'יי בדיסק-און-קי או במייל.' }
        ]
      },
      seo: {
        title: 'חיתוך שיר לריקוד ראשון בחתונה - קיצור שירים לחתונה | CutMP3',
        description: 'חתכו את השיר לריקוד הראשון לאורך המושלם בחינם. קצרו שירי כניסה לחופה ומוזיקה לרחבה ישירות בדפדפן - ללא העלאה, השיר שלכם נשאר פרטי.',
        keywords: 'חיתוך שיר לחתונה, ריקוד ראשון חתונה שיר, קיצור שיר לריקוד ראשון, חיתוך שיר לסלואו, שיר כניסה לחופה, עריכת שיר לחתונה, קיצור שיר לחתונה, חיתוך מוזיקה לחתונה',
        ogTitle: 'חיתוך שיר לריקוד ראשון בחתונה - קיצור שירים לחתונה',
        ogDescription: 'חתכו את השיר לריקוד הראשון לאורך המושלם בחינם. קצרו מוזיקה לחתונה ישירות בדפדפן - ללא העלאה, השיר שלכם נשאר פרטי.',
        twitterTitle: 'חיתוך שיר לריקוד ראשון בחתונה - קיצור שירים לחתונה',
        twitterDescription: 'חתכו את השיר לריקוד הראשון לאורך המושלם בחינם. ללא העלאה - השיר שלכם נשאר פרטי.',
        schemaName: 'חיתוך שיר לריקוד הראשון בחתונה',
        schemaDescription: 'כלי מקוון חינמי לחיתוך וקיצור שירים לריקוד ראשון, כניסה לחופה ופלייליסט לרחבה. פרטי - השיר לעולם לא עוזב את הדפדפן.',
        schemaFeatureList: [
          'קיצור שירים לריקוד הראשון',
          'חיתוך שירי כניסה לחופה ומוזיקה לקבלת פנים',
          'האזנה בלופ לדיוק החיתוך',
          'עורך ויזואלי של גל שמע לחיתוך מדויק',
          'ייצוא כ-MP3 או WAV לדיג\'יי',
          'פרטי - השיר לעולם לא עוזב את הדפדפן'
        ],
        schemaHowToName: 'איך לחתוך שיר לריקוד הראשון',
        schemaHowToDescription: 'קצרו כל שיר לאורך המושלם לריקוד הראשון עם חותך שמע חינמי בדפדפן.',
        schemaHowToSteps: [
          { name: 'העלו את שיר החתונה', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את השיר. הוא נטען מיידית בדפדפן ללא העלאה לשום מקום.' },
          { name: 'בחרו את הקטע שאתם אוהבים', text: 'גררו את הסמנים כדי לשמור את הבית והפזמון שתרצו, בדרך כלל 60-120 שניות. השתמשו בכפתור הלופ כדי להאזין לחיתוך עד שהוא מרגיש טבעי.' },
          { name: 'ייצאו לדיג\'יי', text: 'לחצו על ייצוא והורידו כ-MP3 או WAV. שתפו את הקובץ עם הדיג\'יי או מפיק האירוע - הוא מוכן לניגון.' }
        ]
      }
    },
    'whatsapp-audio-cutter': {
      slug: 'whatsapp-audio-cutter',
      presetSelectionSeconds: 30,
      ui: {
        title: 'חיתוך שמע לוואטסאפ',
        subtitle: 'חתכו שירים והודעות קוליות ל-30 שניות לסטטוס וואטסאפ - בחינם, ללא העלאה',
        heroText: 'חתכו את 30 השניות המושלמות לסטטוס בוואטסאפ. העלו כל שיר או הודעה קולית והכלי יבחר אוטומטית את 30 השניות הראשונות - פשוט גררו את הבחירה לקטע הכי טוב, האזינו, והורידו. ללא התקנת אפליקציה, ללא העלאה, חינם לגמרי.',
        faqItems: [
          { question: 'למה דווקא 30 שניות?', answer: 'סטטוס וואטסאפ מוגבל ל-30 שניות לקליפ. כשטוענים קובץ כאן, הכלי בוחר אוטומטית קטע של 30 שניות - גררו את הבחירה לאורך גל השמע לקטע שתרצו.' },
          { question: 'איך שמים שיר חתוך בסטטוס וואטסאפ?', answer: 'ייצאו את קליפ ה-30 שניות כ-MP3, ואז פתחו את וואטסאפ, היכנסו לסטטוס וצרפו את השמע עם תמונה או סרטון, או השתמשו באפליקציה ליצירת סטטוסים. הקליפ ייכנס בדיוק למגבלת הסטטוס.' },
          { question: 'אפשר לחתוך הודעה קולית לוואטסאפ?', answer: 'כן. העלו את ההודעה הקולית (M4A, MP3 ועוד), חתכו את הקטע שאתם צריכים וייצאו. מושלם לקיצור הודעות קוליות ארוכות לפני שמעבירים אותן הלאה.' },
          { question: 'האם השמע שלי מועלה לאנשהו?', answer: 'לא. הכל מעובד בדפדפן שלכם - השירים וההודעות הקוליות לעולם לא מגיעים לשרת. פרטי, מהיר, ועובד גם בחיבור איטי.' }
        ]
      },
      seo: {
        title: 'חיתוך שמע לוואטסאפ - חיתוך שיר ל-30 שניות לסטטוס | CutMP3',
        description: 'חתכו שמע לסטטוס וואטסאפ בחינם. חתכו כל שיר או הודעה קולית למגבלת ה-30 שניות של הסטטוס ישירות בדפדפן - ללא העלאה, ללא אפליקציה, ללא סימן מים.',
        keywords: 'חיתוך שמע לוואטסאפ, סטטוס וואטסאפ שיר 30 שניות, חיתוך שיר לסטטוס וואטסאפ, חיתוך שיר ל-30 שניות, חותך שמע לוואטסאפ, חיתוך הודעה קולית וואטסאפ, שיר לסטטוס וואטסאפ',
        ogTitle: 'חיתוך שמע לוואטסאפ - חיתוך שיר ל-30 שניות לסטטוס',
        ogDescription: 'חתכו שמע לסטטוס וואטסאפ בחינם. חתכו כל שיר למגבלת ה-30 שניות ישירות בדפדפן - ללא העלאה, ללא אפליקציה.',
        twitterTitle: 'חיתוך שמע לוואטסאפ - חיתוך שיר ל-30 שניות לסטטוס',
        twitterDescription: 'חתכו שמע לסטטוס וואטסאפ בחינם. חתכו כל שיר ל-30 שניות בדפדפן - ללא העלאה.',
        schemaName: 'חיתוך שמע לוואטסאפ',
        schemaDescription: 'כלי מקוון חינמי לחיתוך שירים והודעות קוליות ל-30 שניות לסטטוס וואטסאפ. פרטי - השמע לעולם לא עוזב את הדפדפן.',
        schemaFeatureList: [
          'חיתוך שמע למגבלת ה-30 שניות של סטטוס וואטסאפ',
          'בחירה אוטומטית של 30 שניות',
          'חיתוך שירים והודעות קוליות',
          'עורך ויזואלי של גל שמע לחיתוך מדויק',
          'ייצוא כ-MP3 מוכן לשיתוף',
          'פרטי - השמע לעולם לא עוזב את הדפדפן'
        ],
        schemaHowToName: 'איך לחתוך שמע לסטטוס וואטסאפ',
        schemaHowToDescription: 'חתכו כל שיר או הודעה קולית למגבלת ה-30 שניות של סטטוס וואטסאפ עם חותך שמע חינמי בדפדפן.',
        schemaHowToSteps: [
          { name: 'העלו את השמע', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו שיר או הודעה קולית. הכלי בוחר אוטומטית קטע של 30 שניות.' },
          { name: 'בחרו את 30 השניות הכי טובות', text: 'גררו את הבחירה לאורך גל השמע לקטע שתרצו - הפזמון, השורה הקולעת, הרגע הכי חזק. האזינו עם כפתור הנגן.' },
          { name: 'ייצאו ושתפו', text: 'לחצו על ייצוא, הורידו כ-MP3, וצרפו לסטטוס בוואטסאפ או שלחו בצ\'אט.' }
        ]
      }
    },
    'podcast-trimmer': {
      slug: 'podcast-trimmer',
      ui: {
        title: 'חיתוך פודקאסט אונליין',
        subtitle: 'חתכו שמע של פודקאסט אונליין - פתיחים, סיומות וטעויות, ללא העלאה',
        heroText: 'נקו פרק פודקאסט במהירות בלי להתקין תוכנת עריכה. חתכו פתיח שהתפספס, הסירו שתיקות, או חלצו קטע שיא לרשתות החברתיות - הכל על גל שמע ויזואלי, ישירות בדפדפן. פרקים שטרם פורסמו לא עוזבים את המכשיר שלכם.',
        faqItems: [
          { question: 'איך חותכים פרק פודקאסט?', answer: 'העלו את הפרק ובחרו מצב: חיתוך שומר את הקטע שבחרתם (מעולה לחילוץ קטע שיא), ואילו קיצוץ מסיר את הבחירה ושומר את כל מה שמסביב (מעולה למחיקת טעות או שקט באמצע).' },
          { question: 'מה אורך הפרק המקסימלי?', answer: 'נתמכים קבצים עד 100MB - בערך שעה וחצי עד שעתיים של MP3 בקצב סיביות אופייני לפודקאסטים. פרקים ארוכים עשויים לקחת רגע לטעינה, כי הכל מעובד מקומית במכשיר שלכם.' },
          { question: 'באיזו איכות ייצוא כדאי להשתמש לפלטפורמות פודקאסט?', answer: 'הכלי מייצא MP3 ב-192 kbps, איכות שעולה על ההמלצות של פלטפורמות האחסון הגדולות לפודקאסטים. אפשר גם לייצא WAV ללא דחיסה אם מתכננים עריכה נוספת.' },
          { question: 'האם פרק שטרם פורסם נשאר פרטי?', answer: 'לחלוטין. הפרק מעובד כולו בדפדפן שלכם - שום דבר לא מועלה לשרת, כך שראיונות וטיוטות שטרם פורסמו נשארים במכשיר שלכם.' }
        ]
      },
      seo: {
        title: 'חיתוך פודקאסט אונליין בחינם - עריכת שמע לפודקאסט | CutMP3',
        description: 'חתכו שמע של פודקאסט אונליין בחינם. הסירו פתיחים, סיומות, שתיקות וטעויות על גל שמע ויזואלי - הפרקים לא עוזבים את הדפדפן, ללא הרשמה.',
        keywords: 'חיתוך פודקאסט, עריכת פודקאסט אונליין, חיתוך פרק פודקאסט, עורך פודקאסט אונליין, הסרת שקט מפודקאסט, חיתוך פתיח פודקאסט, חיתוך קטע מפודקאסט, חותך שמע לפודקאסט',
        ogTitle: 'חיתוך פודקאסט אונליין בחינם - עריכת שמע לפודקאסט',
        ogDescription: 'חתכו שמע של פודקאסט אונליין בחינם. הסירו פתיחים, סיומות וטעויות - הפרקים לא עוזבים את הדפדפן.',
        twitterTitle: 'חיתוך פודקאסט אונליין בחינם - עריכת שמע לפודקאסט',
        twitterDescription: 'חתכו שמע של פודקאסט אונליין בחינם. הפרקים לא עוזבים את הדפדפן - ללא העלאה, ללא הרשמה.',
        schemaName: 'חיתוך פודקאסט אונליין',
        schemaDescription: 'כלי מקוון חינמי לחיתוך פרקי פודקאסט: חיתוך פתיחים וסיומות, הסרת שתיקות וטעויות, חילוץ קטעי שיא. פרטי - השמע לעולם לא עוזב את הדפדפן.',
        schemaFeatureList: [
          'חיתוך פתיחים וסיומות של פודקאסט',
          'הסרת טעויות ושתיקות במצב קיצוץ',
          'חילוץ קטעי שיא במצב חיתוך',
          'תמיכה בפרקים עד 100MB',
          'ייצוא MP3 (192 kbps) או WAV ללא דחיסה',
          'פרטי - הפרקים לעולם לא עוזבים את הדפדפן'
        ],
        schemaHowToName: 'איך לחתוך פרק פודקאסט אונליין',
        schemaHowToDescription: 'הסירו פתיחים, סיומות, טעויות ושתיקות מפרק פודקאסט עם כלי חיתוך חינמי בדפדפן.',
        schemaHowToSteps: [
          { name: 'העלו את הפרק', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את הפרק (MP3, WAV, M4A ועוד). הוא נטען מקומית - שום דבר לא מועלה.' },
          { name: 'חתכו או קצצו על גל השמע', text: 'השתמשו במצב קיצוץ להסרת טעות או שקט מהאמצע, או במצב חיתוך לחילוץ קטע. האזינו לעריכה עם כפתור הנגן.' },
          { name: 'ייצאו את התוצאה', text: 'לחצו על ייצוא והורידו כ-MP3 (192 kbps) או WAV. מוכן לפרסום או לשיתוף כקליפ לרשתות.' }
        ]
      }
    },
    'alarm-sound-maker': {
      slug: 'alarm-sound-maker',
      presetSelectionSeconds: 30,
      ui: {
        title: 'יצירת צליל התראה מותאם',
        subtitle: 'הפכו כל שיר לצליל השכמה או התראה - חתכו את 30 השניות המושלמות, בחינם',
        heroText: 'תתעוררו למוזיקה שאתם באמת אוהבים. העלו כל שיר, חתכו קטע אנרגטי של 30 שניות - הכלי בוחר אותו עבורכם אוטומטית - והגדירו אותו כצליל השכמה או התראה באנדרואיד או באייפון. בחינם, ללא אפליקציה, ללא העלאה.',
        faqItems: [
          { question: 'איך מגדירים צליל השכמה מותאם אישית באנדרואיד?', answer: 'ייצאו את הקליפ כ-MP3 ושמרו אותו בטלפון. פתחו את אפליקציית השעון, ערכו שעון מעורר, לחצו על הצליל, ובחרו "הוסף חדש" או עיינו בקבצי המכשיר כדי לבחור את הקליפ שחתכתם.' },
          { question: 'איך מגדירים צליל השכמה מותאם אישית באייפון?', answer: 'באייפון צריך להוסיף צלילי השכמה כרינגטונים. ייצאו את הקליפ כ-MP3, ואז השתמשו ב-GarageBand באייפון (או ב-iTunes/Finder במחשב) כדי להמיר אותו לרינגטון, ובחרו אותו תחת שעון > שעון מעורר > צליל.' },
          { question: 'מה הופך צליל השכמה לטוב?', answer: 'קליפ של 20-30 שניות שמתחיל באנרגיה עובד הכי טוב - בחרו פזמון או קטע שהולך ונבנה במקום פתיחה שקטה, כדי שההתראה תתפוס אתכם מהשנייה הראשונה. הכלי בוחר אוטומטית 30 שניות; גררו את הבחירה לקטע הכי אנרגטי.' },
          { question: 'האם המוזיקה שלי מועלית לאנשהו?', answer: 'לא. השיר מעובד כולו בדפדפן שלכם - שום דבר לא מגיע לשרת. חתכו כמה צלילי השכמה והתראות שתרצו, בחינם.' }
        ]
      },
      seo: {
        title: 'יצירת צליל התראה מותאם אישית מכל שיר - בחינם | CutMP3',
        description: 'צרו צליל השכמה מותאם אישית מכל שיר בחינם. חתכו קליפ של 30 שניות בדפדפן והגדירו אותו כהתראה באנדרואיד או באייפון. ללא העלאה, ללא אפליקציה.',
        keywords: 'צליל התראה מותאם אישית, צליל השכמה משיר, יצירת צליל התראה, רינגטון משיר, חיתוך שיר לשעון מעורר, צליל שעון מעורר מותאם, צליל התראה משיר, יצירת צליל השכמה',
        ogTitle: 'יצירת צליל התראה מותאם אישית מכל שיר - בחינם',
        ogDescription: 'צרו צליל השכמה מותאם אישית מכל שיר בחינם. חתכו קליפ של 30 שניות בדפדפן - ללא העלאה, ללא אפליקציה.',
        twitterTitle: 'יצירת צליל התראה מותאם אישית מכל שיר - בחינם',
        twitterDescription: 'צרו צליל השכמה מותאם אישית מכל שיר בחינם. חתכו קליפ של 30 שניות בדפדפן.',
        schemaName: 'יצירת צליל התראה מותאם',
        schemaDescription: 'כלי מקוון חינמי ליצירת צלילי השכמה והתראה מותאמים אישית מכל שיר. חתכו קליפ של 30 שניות בדפדפן - פרטי, ללא העלאה.',
        schemaFeatureList: [
          'יצירת צלילי השכמה מותאמים אישית מכל שיר',
          'בחירה אוטומטית של 30 שניות',
          'יצירת צלילי התראה מותאמים',
          'עובד באנדרואיד ובאייפון',
          'ייצוא כ-MP3 מוכן להגדרה כהתראה',
          'פרטי - המוזיקה לעולם לא עוזבת את הדפדפן'
        ],
        schemaHowToName: 'איך ליצור צליל השכמה מותאם אישית',
        schemaHowToDescription: 'הפכו כל שיר לצליל השכמה או התראה מותאם אישית עם חותך שמע חינמי בדפדפן.',
        schemaHowToSteps: [
          { name: 'העלו שיר', text: 'לחצו על "בחר קובץ אודיו" או גררו ושחררו את השיר שתרצו להתעורר אליו. קטע של 30 שניות נבחר אוטומטית.' },
          { name: 'בחרו 30 שניות אנרגטיות', text: 'גררו את הבחירה לפזמון או לקטע שהולך ונבנה, כדי שההתראה תתחיל חזק. האזינו עם כפתור הנגן.' },
          { name: 'ייצאו והגדירו כהתראה', text: 'הורידו כ-MP3 והגדירו באפליקציית השעון באנדרואיד, או המירו לרינגטון להתראות באייפון.' }
        ]
      }
    }
  },

  spokeLinks: [
    { slug: 'mp3-wav-converter', label: 'ממיר MP3 ל-WAV', description: 'המרת אודיו ל-MP3 או WAV בחינם' },
    { slug: 'make-iphone-ringtone', label: 'יצירת רינגטון לאייפון', description: 'צרו רינגטונים מותאמים מכל שיר' },
    { slug: 'cut-audio-for-instagram', label: 'שמע לאינסטגרם', description: 'חתכו קליפים לרילס וסטוריז' },
    { slug: 'trim-voice-recording', label: 'חיתוך הקלטה קולית', description: 'ניקוי תזכורות קוליות והקלטות' },
    { slug: 'wedding-first-dance-song', label: 'חיתוך שיר לריקוד הראשון', description: 'חתכו את שיר החתונה לאורך המושלם' },
    { slug: 'whatsapp-audio-cutter', label: 'חיתוך שמע לוואטסאפ', description: 'חתכו קליפים של 30 שניות לסטטוס וואטסאפ' },
    { slug: 'podcast-trimmer', label: 'חיתוך פודקאסט', description: 'חתכו פתיחים, סיומות וטעויות' },
    { slug: 'alarm-sound-maker', label: 'יצירת צליל התראה', description: 'צרו צלילי השכמה מותאמים מכל שיר' }
  ]
}
